import { useState } from 'react'

import Image from 'next/legacy/image'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { DOWNLOAD_NOT_DISPLAY_ROUTER, LOGIN_BEFORE_PATHS } from '@constants/index'
import { useClient } from '@lib/hooks'
import { I18n } from '@utils/index';

import styles from './index.module.less'

type H5DownLoadPropsType = {
  /**
   * uncontrolled 用于下载banner需要特殊展示
   */
  uncontrolled: boolean
}

export default function H5DownLoad ({ uncontrolled = false }: H5DownLoadPropsType) {
  const [visable, setVisable] = useState(true)
  const isPc = useClient()
  const router = useRouter();
  const disable = uncontrolled ? false : DOWNLOAD_NOT_DISPLAY_ROUTER.some(i => i === router.route)
  return (!isPc && visable) ? <div
    className={styles.H5DownLoad}
    style={{
      display: disable ? 'none' : 'flex'
    }}
    data-name='kiki-h5-downLoad-contain'
  >
    <Image
      src={require('@images/h5Logo.webp')}
      width={40}
      height={40}
      layout='fixed'
      alt={'kikitrade'}
    />
    <div className={styles.H5DownLoadContent}>
      <div className='fontMedium'>{I18n.t('BRnhbq8r')}</div>
      <div>{I18n.t('83SgAHlY')}</div>
    </div>
    <Link legacyBehavior href={LOGIN_BEFORE_PATHS.DOWNLOAD}>
      <a
        className={styles.rightLink}
        onClick={() => setVisable(false)}
      >
        <Image
          src={require('@images/h5DownLoad.webp')}
          width={40}
          height={40}
          layout='fixed'
          alt={'kikitrade'}
        />
      </a>
    </Link>
    <div className={styles.close} onClick={() => setVisable(false)} data-name='kiki-h5-downLoad-close'>
      <Image
        src={require('@images/h5Close.webp')}
        width={24}
        height={24}
        layout='fixed'
        alt={'kikitrade'}
      />
    </div>
  </div> : null;
}
